/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminUserBehaviorCategory
 */
export interface AdminUserBehaviorCategory {
    /**
     * 어드민 유저 행동 카테고리 id
     * @type {number}
     * @memberof AdminUserBehaviorCategory
     */
    'adminUserBehaviorCategoryId': number;
    /**
     * 카테고리
     * @type {string}
     * @memberof AdminUserBehaviorCategory
     */
    'category': AdminUserBehaviorCategoryCategoryEnum;
}

export const AdminUserBehaviorCategoryCategoryEnum = {
    ViewupAccountManagement: 'viewupAccountManagement',
    ViewupPlusAccountManagement: 'viewupPlusAccountManagement',
    UserManagement: 'userManagement',
    ExchangeManagement: 'exchangeManagement',
    SupporterAccountManagement: 'supporterAccountManagement',
    PostManagement: 'postManagement',
    ViewPeopleManagement: 'viewPeopleManagement',
    DashboardManagement: 'dashboardManagement',
    NotificationManagement: 'notificationManagement',
    ReportManagement: 'reportManagement'
} as const;

export type AdminUserBehaviorCategoryCategoryEnum = typeof AdminUserBehaviorCategoryCategoryEnum[keyof typeof AdminUserBehaviorCategoryCategoryEnum];


